"use strict";

var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var _ = require("underscore");
var betaURL = require("app/util/config/beta-url");

var AddButton = React.createClass({
  getPropsByEnv: function () {
    return {
      deal: {
        href: betaURL() + "/deals?dealForm=new",
        text: "Adicionar negócio",
        icon: "deal",
        id: "btnAdicionarNegocio"
      },
      organization: {
        href: betaURL() + "/organizations?organizationForm=new",
        text: "Adicionar empresa",
        icon: "organization",
        id: "btnAdicionarEmpresa"
      },
      person: {
        href: betaURL() + "/people?personForm=new",
        text: "Adicionar pessoa",
        icon: "person",
        id: "btnAdicionarPessoa"
      }
    };
  },
  getClassName: function() {
    return this.getPropsByEnv()[this.props.env].className;
  },
  getText: function() {
    return this.getPropsByEnv()[this.props.env].text;
  },
  getHref: function() {
    var hrefParams = this.getHrefParams();
    var base = this.getPropsByEnv()[this.props.env].href;
    return base + (hrefParams ? "&" + hrefParams : "");
  },
  getIcon: function() {
    return this.getPropsByEnv()[this.props.env].icon;
  },
  getHrefParams: function () {
    var paramMap = { idPessoa: "person_id", idEmpresa: "organization_id" };
    return _.map(this.props.addButtonProps, function (value, key) {
      return (paramMap[key] || key) + "=" + value;
    }).join("&");
  },
  render: function () {
    return (
      <a id={this.getPropsByEnv()[this.props.env].id} className="btn btn-primary ta-l" href={this.getHref()}>
        <span className="flex-center-all">
          <Icon custom={true} icon={this.getIcon()} style={{ color: "#52FF90" }} />
          <span>{this.getText()}</span>
        </span>
      </a>
    );
  }
});

module.exports = AddButton;



// WEBPACK FOOTER //
// ./app/shared/components/Button/add-button.jsx